module.exports = __webpack_public_path__ + "static/media/default.434ce675.png";